import React from "react";
import Layout from "../Layout";
import Form from "./form";
import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";
import useError from "Hooks/useError";
import { message } from "constants/message";
import { withRouter } from "react-router";

function Group(props) {
  const { params } = props.match;
  const accountId = parseInt(params.accountId, 10);
  const groupId = parseInt(params.groupId, 10);

  const { request } = useApi();
  const auth = useAuth();
  const stateError = useError();
  const messages = message();
  const [account, setAccount] = React.useState({id:null, name: ""});
  const [group, setGroup] = React.useState(null);

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - 多メディア収集グループ更新";
  }, []);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchAccount();
    fetchGroup();
  }, [auth.state.token]);

  const fetchAccount = () => {
    request({
      method: "GET",
      url: `admin/accounts/${accountId}`,
    }).then((result) => {
      setAccount({
        id: result.data.data.id,
        name: result.data.data.name,
      });
    });
  }

  const fetchGroup = () => {
    request({
      method: "GET",
      url: `admin/media/${accountId}/groups/${groupId}`,
    }).then((result) => {
      const data = {
        name: result.data.data.name,
        desc: result.data.data.desc,
        priority: result.data.data.priority,
      }

      setGroup(data);
    });
  }

  const handleSubmit = (group) => {
    request({
      method: "PUT",
      url: `admin/media/${accountId}/groups/${groupId}`,
      data: {
        name: group.name,
        desc: group.desc,
        priority: group.priority,
      },
    })
      .then((data) => {
        stateError.initialize();
        props.history.push(`/admin/media/accounts/group/${accountId}?success=edit`);
      })
      .catch((errors) => {
        let errorMsg = messages.validation.common;

        // エラーの内容が収集グループ名の重複かチェック
        // 重複の場合、エラーメッセージを変更
        if(errors.response.data.errors.name){
          (errors.response.data.errors.name).map((error) => {
            if (error.error === "taken") {
              errorMsg = (messages.validation.taken).replace("$1", "収集グループ名");
            }
          })
        }

        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: errorMsg,
          },
        });
      });
  };

  return (
    <Layout
      content={
        <Form
          account={account}
          submit={handleSubmit}
          group={group}
          isEdit={true}
        />
      }
    />
  );
}
export default withRouter(Group);
